import { Box, Button } from '@mantine/core'

import { navigate } from '@redwoodjs/router'

import IconCheckmark from 'src/icons/IconCheckmark'

interface FormSubmitScreenProps {
  applicationId?: string
  phone?: string
  isOfficeJob?: boolean
}

const FormSubmitScreen = ({
  applicationId,
  phone,
  isOfficeJob,
}: FormSubmitScreenProps) => {
  const title = 'Thank you for your application!'
  const subTitle = isOfficeJob
    ? 'Our team will contact you if we decide to move forward with your application.'
    : 'Please click the button below to complete your DoT application.'

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4">
      <Box className="flex h-24 w-24 flex-col items-center justify-center rounded-full bg-doubleNickel-brand-25">
        <IconCheckmark className="h-14 w-14 fill-none stroke-doubleNickel-brand-500" />
      </Box>
      <div className="flex flex-col gap-4">
        <div className="text-center text-lg font-semibold text-doubleNickel-gray-800">
          {title}
        </div>
        <div className="text-md text-center text-doubleNickel-gray-700">
          {subTitle}
        </div>
      </div>

      {!isOfficeJob && (
        <Button
          size="md"
          variant="filled"
          className="h-16 bg-doubleNickel-brand-500 text-sm"
          onClick={() =>
            navigate(
              `/driver-login?redirectTo=/driver-application?applicationId=${applicationId}&phone=${
                phone ? encodeURIComponent(phone) : ''
              }`
            )
          }
        >
          Continue to DoT Application
        </Button>
      )}
    </div>
  )
}

export default FormSubmitScreen
